var _rect, _br, _br2, _br3, _br4, _br5, _text, _path, _path2, _text2, _path3, _path4, _path5, _path6, _br6, _text3, _path7, _path8, _path9, _path10, _text4, _path11, _path12, _text5, _path13, _path14, _text6, _rect2, _rect3, _text7, _path15, _path16, _rect4, _path17, _text8, _path18, _path19, _text9, _rect5, _path20, _text10, _image, _path21, _path22, _path23, _path24, _path25, _path26, _text11, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "899px",
    height: "472px",
    viewBox: "-0.5 -0.5 899 472",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T03:55:14.485Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"YYURrA-vA7Rs628otqSb\" version=\"16.5.1\" type=\"device\"><diagram id=\"4M8INFpIej6XJllK5yvl\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f78e04-1-d05c17-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(208, 92, 23)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247, 142, 4)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-4d72f3-1-3334b9-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(51, 52, 185)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(77, 114, 243)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-60a337-1-277116-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(39, 113, 22)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96, 163, 55)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 647,
    y: 0,
    width: 220,
    height: 200,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 218,
      height: 1,
      paddingTop: 100,
      marginLeft: 648
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 19
    }
  }, _br || (_br = /*#__PURE__*/React.createElement("br", null)), _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null)), "Replications", _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)), "(AWS Cloud + OnPerm)", _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 757,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Replications...")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 247 90 L 897 90 L 897 450 L 247 450 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 253.09 97.18 C 253.01 97.18 252.93 97.19 252.85 97.19 C 252.5 97.19 252.15 97.23 251.81 97.32 C 251.53 97.39 251.25 97.49 250.98 97.62 C 250.9 97.65 250.84 97.7 250.79 97.76 C 250.75 97.83 250.74 97.91 250.74 97.99 L 250.74 98.32 C 250.74 98.46 250.78 98.53 250.88 98.53 L 250.99 98.53 L 251.22 98.44 C 251.45 98.35 251.69 98.27 251.94 98.21 C 252.17 98.16 252.41 98.13 252.65 98.13 C 253.04 98.09 253.43 98.2 253.74 98.44 C 253.97 98.74 254.09 99.12 254.05 99.5 L 254.05 99.99 C 253.78 99.93 253.54 99.88 253.29 99.84 C 253.05 99.81 252.81 99.79 252.57 99.79 C 251.98 99.76 251.4 99.94 250.94 100.31 C 250.54 100.65 250.32 101.15 250.34 101.68 C 250.31 102.15 250.49 102.62 250.82 102.96 C 251.18 103.29 251.66 103.46 252.15 103.44 C 252.91 103.45 253.63 103.11 254.11 102.51 C 254.18 102.66 254.24 102.79 254.31 102.91 C 254.38 103.02 254.46 103.12 254.55 103.21 C 254.6 103.27 254.67 103.31 254.75 103.31 C 254.81 103.31 254.87 103.29 254.92 103.25 L 255.34 102.97 C 255.41 102.93 255.46 102.86 255.47 102.77 C 255.47 102.72 255.45 102.67 255.42 102.62 C 255.34 102.47 255.26 102.31 255.21 102.14 C 255.15 101.95 255.12 101.75 255.13 101.55 L 255.14 99.37 C 255.2 98.77 255 98.18 254.59 97.74 C 254.17 97.39 253.64 97.19 253.09 97.18 Z M 266.89 97.19 C 266.78 97.19 266.68 97.19 266.57 97.2 C 266.29 97.2 266 97.24 265.73 97.31 C 265.47 97.38 265.23 97.5 265.01 97.66 C 264.82 97.81 264.66 97.99 264.54 98.21 C 264.42 98.43 264.35 98.67 264.36 98.92 C 264.36 99.27 264.48 99.61 264.69 99.89 C 264.97 100.22 265.34 100.46 265.76 100.56 L 266.72 100.87 C 266.97 100.93 267.2 101.05 267.39 101.22 C 267.51 101.35 267.58 101.51 267.57 101.69 C 267.58 101.94 267.45 102.18 267.23 102.31 C 266.93 102.48 266.6 102.56 266.26 102.54 C 265.99 102.54 265.72 102.51 265.46 102.45 C 265.22 102.4 264.98 102.32 264.75 102.22 L 264.58 102.15 C 264.54 102.14 264.5 102.14 264.46 102.15 C 264.36 102.15 264.31 102.22 264.31 102.36 L 264.31 102.69 C 264.31 102.76 264.32 102.82 264.35 102.89 C 264.4 102.97 264.47 103.03 264.56 103.07 C 264.8 103.19 265.06 103.28 265.32 103.34 C 265.66 103.41 266 103.45 266.35 103.45 L 266.33 103.46 C 266.66 103.45 266.98 103.4 267.29 103.3 C 267.55 103.22 267.8 103.09 268.01 102.92 C 268.21 102.77 268.38 102.57 268.49 102.34 C 268.61 102.1 268.67 101.83 268.66 101.56 C 268.67 101.23 268.56 100.9 268.36 100.63 C 268.09 100.32 267.73 100.09 267.33 99.99 L 266.39 99.69 C 266.13 99.61 265.88 99.49 265.67 99.32 C 265.54 99.2 265.47 99.03 265.47 98.85 C 265.46 98.61 265.58 98.38 265.79 98.25 C 266.06 98.11 266.36 98.05 266.67 98.06 C 267.11 98.06 267.55 98.14 267.96 98.32 C 268.04 98.37 268.12 98.4 268.21 98.41 C 268.31 98.41 268.36 98.34 268.36 98.19 L 268.36 97.88 C 268.37 97.8 268.35 97.72 268.31 97.66 C 268.25 97.59 268.18 97.54 268.11 97.49 L 267.83 97.38 L 267.45 97.27 L 267.01 97.2 C 266.97 97.2 266.93 97.19 266.89 97.19 Z M 263.02 97.36 C 262.94 97.35 262.86 97.38 262.79 97.42 C 262.72 97.5 262.68 97.59 262.66 97.69 L 261.51 102.14 L 260.47 97.71 C 260.45 97.61 260.41 97.52 260.34 97.44 C 260.26 97.39 260.17 97.37 260.07 97.38 L 259.54 97.38 C 259.44 97.37 259.35 97.39 259.27 97.44 C 259.2 97.51 259.15 97.61 259.14 97.71 L 258.09 102.14 L 256.97 97.7 C 256.95 97.6 256.91 97.51 256.84 97.44 C 256.76 97.39 256.67 97.36 256.58 97.37 L 255.92 97.37 C 255.81 97.37 255.76 97.43 255.76 97.54 C 255.77 97.63 255.79 97.72 255.82 97.81 L 257.38 102.95 C 257.4 103.05 257.45 103.14 257.52 103.21 C 257.6 103.26 257.69 103.29 257.78 103.28 L 258.36 103.26 C 258.46 103.27 258.55 103.25 258.63 103.19 C 258.7 103.12 258.74 103.03 258.76 102.93 L 259.79 98.64 L 260.82 102.93 C 260.83 103.03 260.88 103.12 260.95 103.19 C 261.03 103.25 261.12 103.27 261.21 103.26 L 261.79 103.26 C 261.88 103.27 261.97 103.25 262.04 103.2 C 262.11 103.13 262.16 103.03 262.18 102.94 L 263.79 97.79 C 263.84 97.72 263.84 97.63 263.84 97.63 C 263.84 97.59 263.84 97.56 263.84 97.52 C 263.84 97.48 263.82 97.43 263.79 97.4 C 263.76 97.37 263.72 97.35 263.67 97.36 L 263.05 97.36 C 263.04 97.36 263.03 97.36 263.02 97.36 Z M 252.65 100.62 C 252.7 100.62 252.75 100.62 252.8 100.62 L 253.43 100.62 C 253.64 100.64 253.85 100.67 254.06 100.71 L 254.06 101.01 C 254.07 101.21 254.05 101.4 254 101.59 C 253.96 101.75 253.88 101.9 253.77 102.01 C 253.61 102.21 253.39 102.36 253.14 102.44 C 252.91 102.52 252.67 102.56 252.43 102.56 C 252.18 102.6 251.93 102.53 251.73 102.37 C 251.55 102.18 251.46 101.92 251.49 101.66 C 251.47 101.36 251.59 101.08 251.81 100.89 C 252.06 100.72 252.35 100.62 252.65 100.62 Z M 268.04 104.72 C 267.34 104.73 266.51 104.89 265.88 105.33 C 265.69 105.47 265.72 105.63 265.94 105.63 C 266.64 105.54 268.21 105.35 268.5 105.71 C 268.78 106.06 268.19 107.54 267.94 108.21 C 267.86 108.41 268.04 108.49 268.21 108.34 C 269.39 107.36 269.72 105.3 269.46 105 C 269.32 104.85 268.74 104.71 268.04 104.72 Z M 249.65 105.1 C 249.5 105.12 249.42 105.3 249.58 105.44 C 252.29 107.89 255.82 109.23 259.48 109.21 C 262.37 109.22 265.2 108.36 267.59 106.74 C 267.95 106.47 267.63 106.07 267.26 106.23 C 264.87 107.24 262.3 107.76 259.71 107.77 C 256.23 107.78 252.82 106.87 249.81 105.14 C 249.75 105.11 249.69 105.1 249.65 105.1 Z M 247 90 L 272 90 L 272 115 L 247 115 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 618,
      height: 1,
      paddingTop: 97,
      marginLeft: 279
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Cloud")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 279,
    y: 109,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "AWS Cloud")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 455 309 L 580.63 309",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 585.88 309 L 578.88 312.5 L 580.63 309 L 578.88 305.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 377 270 L 455 270 L 455 348 L 377 348 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 409.39 326.43 L 412.66 326.43 L 412.66 324.19 L 409.39 324.19 Z M 414.89 326.43 L 418.23 326.43 L 418.23 324.19 L 414.89 324.19 Z M 401.53 280.78 L 387.05 287.97 L 387.05 332.62 L 401.53 337.52 Z M 403.75 294.99 L 403.75 324.19 L 407.09 324.19 L 407.09 326.43 L 403.75 326.43 L 403.75 339.08 C 403.75 339.44 403.58 339.78 403.29 339.99 C 403.1 340.13 402.87 340.2 402.64 340.2 C 402.52 340.2 402.4 340.18 402.29 340.14 L 385.59 334.5 C 385.13 334.34 384.83 333.91 384.83 333.43 L 384.83 287.27 C 384.83 286.84 385.07 286.45 385.45 286.26 L 402.15 277.97 C 402.49 277.8 402.9 277.82 403.23 278.03 C 403.55 278.23 403.75 278.59 403.75 278.98 L 403.75 292.75 L 407.09 292.75 L 407.09 294.99 Z M 420.45 326.43 L 423.79 326.43 L 423.79 324.19 L 420.45 324.19 Z M 420.53 294.99 L 423.79 294.99 L 423.79 292.75 L 420.53 292.75 Z M 414.96 294.99 L 418.23 294.99 L 418.23 292.75 L 414.96 292.75 Z M 409.39 294.99 L 412.66 294.99 L 412.66 292.75 L 409.39 292.75 Z M 444.95 287.97 L 430.47 280.78 L 430.47 337.52 L 444.95 332.62 Z M 447.17 333.43 C 447.17 333.91 446.87 334.34 446.41 334.5 L 429.71 340.14 C 429.6 340.18 429.48 340.2 429.36 340.2 C 429.13 340.2 428.9 340.13 428.71 339.99 C 428.42 339.78 428.25 339.44 428.25 339.08 L 428.25 326.43 L 426.09 326.43 L 426.09 324.19 L 428.25 324.19 L 428.25 294.99 L 426.09 294.99 L 426.09 292.75 L 428.25 292.75 L 428.25 278.98 C 428.25 278.59 428.45 278.23 428.77 278.03 C 429.1 277.82 429.51 277.8 429.85 277.97 L 446.55 286.26 C 446.93 286.45 447.17 286.84 447.17 287.27 Z M 419.27 302.13 L 417.19 301.33 L 411.62 315.92 L 413.7 316.73 Z M 426.81 309.26 C 427.24 308.82 427.24 308.11 426.81 307.67 L 422.35 303.18 L 420.78 304.77 L 424.45 308.47 L 420.78 312.16 L 422.35 313.75 Z M 409.65 313.75 L 405.19 309.26 C 404.76 308.82 404.76 308.11 405.19 307.67 L 409.65 303.18 L 411.22 304.77 L 407.55 308.47 L 411.22 312.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 355,
      marginLeft: 416
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "API Gateway", _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null)))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 416,
    y: 367,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "API Gateway&#xa;")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 665 309.04 L 806 309.04 L 806 325.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 806 330.88 L 802.5 323.88 L 806 325.63 L 809.5 323.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 587 270 L 665 270 L 665 348 L 587 348 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 612.67 337.97 L 598.83 337.97 L 614.13 305.99 L 621.06 320.26 Z M 615.13 302.93 C 614.94 302.55 614.55 302.3 614.13 302.3 L 614.12 302.3 C 613.69 302.3 613.3 302.55 613.12 302.94 L 596.05 338.61 C 595.89 338.95 595.91 339.36 596.11 339.68 C 596.32 340 596.68 340.2 597.06 340.2 L 613.37 340.2 C 613.8 340.2 614.2 339.95 614.38 339.56 L 623.31 320.73 C 623.46 320.43 623.46 320.07 623.31 319.77 Z M 653.88 337.97 L 640.13 337.97 L 618.08 291.81 C 617.9 291.42 617.5 291.17 617.07 291.17 L 608.08 291.17 L 608.09 280.03 L 625.72 280.03 L 647.67 326.19 C 647.85 326.58 648.25 326.83 648.68 326.83 L 653.88 326.83 Z M 655 324.6 L 649.38 324.6 L 627.43 278.44 C 627.25 278.05 626.85 277.8 626.42 277.8 L 606.97 277.8 C 606.36 277.8 605.86 278.3 605.85 278.91 L 605.84 292.28 C 605.84 292.58 605.96 292.86 606.17 293.07 C 606.38 293.28 606.66 293.4 606.96 293.4 L 616.37 293.4 L 638.42 339.56 C 638.61 339.95 639 340.2 639.43 340.2 L 655 340.2 C 655.61 340.2 656.11 339.7 656.11 339.09 L 656.11 325.71 C 656.11 325.1 655.61 324.6 655 324.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 355,
      marginLeft: 626
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Lambda functions")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 626,
    y: 367,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Lambda functi...")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 767 332 L 845 332 L 845 410 L 767 410 Z",
    fill: "url(#mx-gradient-4d72f3-1-3334b9-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 819.42 387.55 C 815.7 390.55 807.9 392.14 800.43 392.14 C 792.97 392.14 785.16 390.55 781.44 387.55 L 781.44 393.6 L 781.44 393.6 C 781.44 396.62 789.24 399.99 800.43 399.99 C 811.62 399.99 819.41 396.63 819.42 393.61 Z M 819.43 376.04 L 821.65 376.03 L 821.65 376.04 C 821.65 377.38 820.98 378.64 819.67 379.79 C 821.26 381.19 821.65 382.57 821.65 383.54 C 821.65 383.55 821.65 383.56 821.65 383.56 L 821.65 393.6 L 821.65 393.6 C 821.65 399.19 810.72 402.2 800.43 402.2 C 790.17 402.2 779.27 399.2 779.22 393.64 C 779.22 393.64 779.21 393.63 779.21 393.62 L 779.21 383.54 C 779.21 383.54 779.22 383.54 779.22 383.53 C 779.22 382.55 779.62 381.19 781.21 379.79 C 779.63 378.39 779.23 377.03 779.22 376.06 L 779.22 376.06 C 779.22 376.06 779.21 376.06 779.21 376.05 L 779.21 365.97 C 779.21 365.96 779.22 365.96 779.22 365.96 C 779.22 364.98 779.62 363.61 781.21 362.22 C 779.63 360.82 779.23 359.46 779.22 358.49 L 779.22 358.49 C 779.22 358.49 779.21 358.48 779.21 358.48 L 779.21 348.39 C 779.21 348.39 779.22 348.39 779.22 348.38 C 779.24 342.81 790.16 339.8 800.43 339.8 C 806.24 339.8 811.82 340.72 815.74 342.33 L 814.89 344.37 C 811.23 342.87 805.96 342.01 800.43 342.01 C 789.24 342.01 781.44 345.38 781.44 348.4 C 781.44 351.42 789.24 354.79 800.43 354.79 C 800.74 354.79 801.03 354.79 801.33 354.78 L 801.42 356.98 C 801.09 357 800.76 357 800.43 357 C 792.97 357 785.16 355.41 781.44 352.4 L 781.44 358.45 L 781.44 358.45 L 781.44 358.48 C 781.46 359.64 782.64 360.65 783.64 361.29 C 786.64 363.2 792.01 364.51 798 364.78 L 797.9 366.99 C 791.83 366.71 786.52 365.45 783.1 363.53 C 782.25 364.15 781.44 365.01 781.44 365.97 C 781.44 368.99 789.24 372.36 800.43 372.36 C 801.53 372.36 802.62 372.32 803.68 372.25 L 803.83 374.46 C 802.73 374.53 801.58 374.57 800.43 374.57 C 792.97 374.57 785.16 372.98 781.44 369.97 L 781.44 376.03 L 781.44 376.03 C 781.46 377.21 782.64 378.22 783.64 378.87 C 787.07 381.05 793.5 382.42 800.43 382.42 L 800.92 382.42 L 800.92 384.63 L 800.43 384.63 C 793.39 384.63 786.99 383.32 783.08 381.11 C 782.24 381.74 781.44 382.59 781.44 383.54 C 781.44 386.57 789.24 389.93 800.43 389.93 C 811.62 389.93 819.41 386.57 819.42 383.55 L 819.42 383.54 L 819.42 383.54 C 819.42 382.58 818.62 381.73 817.78 381.1 C 817.24 381.41 816.65 381.71 815.99 381.98 L 815.14 379.94 C 815.95 379.61 816.65 379.25 817.22 378.87 C 818.23 378.21 819.43 377.19 819.43 376.04 Z M 828.97 359.88 L 822.73 359.88 C 822.36 359.88 822.01 359.69 821.8 359.39 C 821.6 359.09 821.55 358.7 821.69 358.36 L 825.49 348.87 L 811.1 348.87 L 804.42 362.13 L 811.53 362.13 C 811.89 362.13 812.22 362.3 812.43 362.58 C 812.64 362.87 812.7 363.23 812.59 363.57 L 806.24 383.36 Z M 832.39 359.54 L 804.53 388.32 C 804.32 388.54 804.02 388.65 803.73 388.65 C 803.53 388.65 803.34 388.6 803.16 388.5 C 802.71 388.24 802.51 387.71 802.67 387.22 L 810.01 364.34 L 802.62 364.34 C 802.23 364.34 801.87 364.14 801.67 363.82 C 801.46 363.49 801.45 363.08 801.62 362.74 L 809.42 347.27 C 809.61 346.89 809.99 346.66 810.42 346.66 L 827.13 346.66 C 827.5 346.66 827.85 346.84 828.05 347.14 C 828.26 347.45 828.3 347.83 828.17 348.17 L 824.37 357.67 L 831.59 357.67 C 832.03 357.67 832.44 357.93 832.61 358.34 C 832.79 358.75 832.7 359.22 832.39 359.54 Z M 783.06 394.04 C 784.64 394.93 786.63 395.67 788.97 396.26 L 789.52 394.11 C 787.4 393.59 785.55 392.9 784.17 392.12 Z M 788.97 378.58 L 789.52 376.43 C 787.4 375.9 785.55 375.21 784.17 374.43 L 783.06 376.35 C 784.64 377.24 786.63 377.99 788.97 378.58 Z M 783.06 358.67 L 784.17 356.75 C 785.55 357.53 787.4 358.22 789.52 358.75 L 788.97 360.89 C 786.63 360.31 784.64 359.56 783.06 358.67 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 417,
      marginLeft: 806
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "DynamoDB")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 806,
    y: 429,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DynamoDB")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 327 120 L 405 120 L 405 198 L 327 198 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 389.28 162.22 L 389.71 159.21 C 393.66 161.57 393.71 162.55 393.71 162.58 C 393.7 162.58 393.03 163.14 389.28 162.22 Z M 387.12 161.62 C 380.3 159.56 370.8 155.2 366.96 153.39 C 366.96 153.37 366.96 153.36 366.96 153.34 C 366.96 151.86 365.76 150.66 364.28 150.66 C 362.81 150.66 361.61 151.86 361.61 153.34 C 361.61 154.82 362.81 156.02 364.28 156.02 C 364.93 156.02 365.52 155.78 365.98 155.39 C 370.51 157.53 379.93 161.82 386.8 163.85 L 384.08 183.03 C 384.07 183.08 384.07 183.13 384.07 183.18 C 384.07 184.87 376.6 187.97 364.39 187.97 C 352.05 187.97 344.49 184.87 344.49 183.18 C 344.49 183.13 344.49 183.08 344.48 183.03 L 338.81 141.57 C 343.72 144.95 354.29 146.74 364.39 146.74 C 374.48 146.74 385.03 144.96 389.96 141.59 Z M 338.21 137.25 C 338.29 135.78 346.71 130.03 364.39 130.03 C 382.07 130.03 390.5 135.78 390.58 137.25 L 390.58 137.75 C 389.61 141.04 378.69 144.51 364.39 144.51 C 350.07 144.51 339.15 141.02 338.21 137.73 Z M 392.81 137.27 C 392.81 133.41 381.74 127.8 364.39 127.8 C 347.05 127.8 335.98 133.41 335.98 137.27 L 336.08 138.11 L 342.27 183.27 C 342.41 188.32 355.88 190.2 364.39 190.2 C 374.94 190.2 386.15 187.77 386.3 183.27 L 388.97 164.44 C 390.45 164.8 391.68 164.98 392.66 164.98 C 393.98 164.98 394.87 164.66 395.41 164.01 C 395.85 163.49 396.02 162.85 395.89 162.16 C 395.61 160.62 393.77 158.96 390.05 156.83 L 392.69 138.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 205,
      marginLeft: 366
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "S3")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 366,
    y: 217,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "S3")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 230,
    width: 390,
    height: 180,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 230,
    width: 180,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 178,
      height: 1,
      paddingTop: 240,
      marginLeft: 328
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "AWS Serverless Architecture")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 417,
    y: 244,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "AWS Serverless Architecture")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 151.51 210 L 237.04 210 L 237.04 309.04 L 370.63 309",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 375.88 309 L 368.88 312.5 L 370.63 309 L 368.88 305.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 180,
    width: 84.51,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 67 180 L 67 181.33 L 67 240 L 151.51 240 L 151.51 180 Z M 69.65 182.66 L 148.86 182.66 L 148.86 192.26 L 69.65 192.26 Z M 144.35 184.99 C 143.03 184.99 141.96 186.06 141.96 187.39 C 141.96 188.02 142.22 188.63 142.66 189.08 C 143.11 189.53 143.72 189.79 144.35 189.79 C 144.98 189.79 145.59 189.53 146.04 189.08 C 146.49 188.63 146.74 188.02 146.74 187.39 C 146.74 186.75 146.49 186.14 146.04 185.69 C 145.59 185.24 144.98 184.99 144.35 184.99 Z M 136.19 185.01 C 135.56 185.01 134.95 185.26 134.5 185.71 C 134.06 186.16 133.8 186.77 133.8 187.4 C 133.8 188.04 134.06 188.65 134.5 189.1 C 134.95 189.55 135.56 189.8 136.19 189.8 C 136.82 189.8 137.43 189.55 137.88 189.1 C 138.33 188.65 138.58 188.04 138.58 187.4 C 138.58 186.77 138.33 186.16 137.88 185.71 C 137.43 185.26 136.82 185.01 136.19 185.01 Z M 128.07 185.02 C 127.43 185.02 126.83 185.27 126.38 185.72 C 125.93 186.17 125.68 186.78 125.68 187.42 C 125.68 188.05 125.93 188.66 126.38 189.11 C 126.83 189.56 127.43 189.82 128.07 189.82 C 128.7 189.82 129.31 189.56 129.75 189.11 C 130.2 188.66 130.45 188.05 130.45 187.42 C 130.45 186.09 129.38 185.02 128.07 185.02 Z M 69.65 194.92 L 148.86 194.92 L 148.86 237.34 L 69.65 237.34 Z M 101.86 204.7 L 106.22 221.6 L 110.55 217.23 L 120.23 227.02 L 124.04 223.23 L 114.31 213.44 L 118.62 209.13 Z",
    fill: "#434445",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 247,
      marginLeft: 109
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Browser")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 109,
    y: 259,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Browser")))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 143.42 385.04 L 237.04 385.04 L 237.04 309.04 L 370.63 309",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 375.88 309 L 368.88 312.5 L 370.63 309 L 368.88 305.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 309,
      marginLeft: 287
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Requests")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 287,
    y: 313,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Requests")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.09,
    y: 320,
    width: 68.33,
    height: 130,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 96.75 334.28 C 97.23 334.28 97.63 334.67 97.63 335.16 C 97.63 335.64 97.23 336.03 96.75 336.03 C 96.26 336.03 95.87 335.64 95.87 335.16 C 95.87 334.67 96.26 334.28 96.75 334.28 Z M 96.75 340.31 C 99.59 340.31 101.9 338 101.9 335.16 C 101.9 332.32 99.59 330.01 96.75 330.01 C 93.91 330.01 91.6 332.32 91.6 335.16 C 91.6 338 93.91 340.31 96.75 340.31 Z M 106.46 337.96 L 121.74 337.96 L 121.74 332.26 L 106.46 332.26 Z M 132.56 441.73 L 85.95 441.73 C 83.1 441.73 80.79 439.46 80.79 436.67 L 80.79 432.65 L 137.72 432.65 L 137.72 436.67 C 137.72 439.46 135.4 441.73 132.56 441.73 Z M 80.79 347.65 L 137.72 347.65 L 137.72 426.96 L 80.79 426.96 L 80.79 399.33 Z M 88.33 328.27 L 130.18 328.27 C 134.34 328.27 137.72 331.6 137.72 335.68 L 137.72 341.95 L 80.79 341.95 L 80.79 335.68 C 80.79 331.6 84.17 328.27 88.33 328.27 Z M 130.22 322.58 L 130.18 322.58 L 88.33 322.58 C 81.03 322.58 75.09 328.46 75.09 335.68 L 75.09 436.67 C 75.09 442.6 79.96 447.42 85.95 447.42 L 132.56 447.42 C 138.55 447.42 143.42 442.6 143.42 436.67 L 143.42 335.68 L 143.42 335.67 C 143.42 328.46 137.51 322.6 130.22 322.58 Z",
    fill: "#232f3d",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 457,
      marginLeft: 109
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Mobile")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 109,
    y: 469,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mobile")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 678.89,
    y: 19.5,
    width: 155.22,
    height: 80,
    xlinkHref: "https://upload.wikimedia.org/wikipedia/zh/thumb/6/62/MySQL.svg/1200px-MySQL.svg.png",
    preserveAspectRatio: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 665 309 L 807.04 309.04 L 807.04 206.37",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 807.04 201.12 L 810.54 208.12 L 807.04 206.37 L 803.54 208.12 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 327 149.04 L 6.96 149.04 L 6.96 210 L 60.63 210",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 65.88 210 L 58.88 213.5 L 60.63 210 L 58.88 206.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 327 149.04 L 6.96 149.04 L 6.96 385.04 L 68.72 385.04",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 73.97 385.04 L 66.97 388.54 L 68.72 385.04 L 66.97 381.54 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 148,
      marginLeft: 117
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 19,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    }
  }, "Static Web Content"))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 117,
    y: 154,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "19px",
    textAnchor: "middle"
  }, "Static Web Content"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerless);
export default __webpack_public_path__ + "static/media/Serverless.130212bdd46449d254eff1015e11f046.svg";
export { ForwardRef as ReactComponent };